import { Action } from '@/store/workflow/actions'
import { Process, RunningProcess, VariablePayload } from '@/store/workflow/types'
import { filter, IterateeShorthand } from 'lodash'
import Vue, { VNode } from 'vue'
import { ScopedSlotReturnValue } from 'vue/types/vnode'

export default Vue.extend({
  computed: {
    filters() {
      const filters: IterateeShorthand<RunningProcess> = {}

      // select by process business key
      if (typeof this.inProcess === 'string') {
        filters.business_key = this.inProcess
      } else if (typeof this.inProcess === 'object') {
        filters.id = this.inProcess.id
      }

      // select by case variable
      filters.case_id = this.case ? this.case : this.$store.getters.currentCaseId

      return filters
    },
    filteredProcesses(): RunningProcess[] {
      const processes: RunningProcess[] = this.$store.getters['workflow/processes']
      return filter(processes, this.filters)
    },
  },
  inject: {
    process: {
      default: null,
    },
  },
  props: {
    case: {
      type: String,
    },
    inProcess: {
      default(): Process | null {
        return (this as any).process
      },
      type: [String, Object as () => Process],
    },
    name: {
      required: true,
      type: String,
    },
    tag: {
      default: 'div',
      type: String,
    },
  },
  render(): VNode {
    const Tag = this.tag
    const filteredProcesses = this.filteredProcesses
    const content: ScopedSlotReturnValue = []

    if (filteredProcesses.length > 0) {
      const now = new Date()
      const defaultSlot = this.$scopedSlots.default
      const elseSlot = this.$scopedSlots.else

      filteredProcesses.forEach(process => {
        const pendingTimers = process.pending_timers.filter(
          timer => timer.activity_id === this.name
        )

        if (elseSlot && pendingTimers.length === 0) {
          content.push(
            elseSlot({
              process,
            })
          )
        }

        if (!defaultSlot) {
          return
        }

        pendingTimers.forEach(timer => {
          const due = new Date(timer.due)
          const skip = () => {
            return this.$store.dispatch({
              execution: timer,
              type: 'workflow/skipExecution',
            })
          }

          const trigger = (date?: Date) => {
            return this.$store.dispatch({
              dueDate: date || new Date(),
              jobId: timer.id,
              type: 'workflow/updateDueDate',
            })
          }

          content.push(
            defaultSlot({
              due,
              dueIn: due.getTime() - now.getTime(),
              process,
              skip,
              timer,
              trigger,
            })
          )

          content.push(
            <portal to="pending-timers">
              <div class="timer">
                <div class="activitiy">
                  {process.business_key}/{timer.activity_id}
                </div>
                <div class="due">{timer.due}</div>
                <button class="skip" onClick={() => trigger(new Date())}>
                  trigger
                </button>
              </div>
            </portal>
          )
        })
      })
    }

    if (filteredProcesses.length === 0 && this.$scopedSlots.else) {
      content.push(this.$scopedSlots.else({}))
    }
    return <Tag {...this.$attrs}>{content}</Tag>
  },
})
